import gql from 'graphql-tag';

export default gql`
  query XdpSpecializationDataQuery($slug: String!) {
    XdpV1Resource {
      slug(productType: "SPECIALIZATION", slug: $slug) {
        elements {
          name
          id
          slug
          xdpMetadata {
            __typename
            ... on XdpV1_sdpMetadataMember {
              sdpMetadata {
                id
                productVariant
              }
            }
          }
        }
      }
    }
  }
`;
